import * as React from "react";
import { useTranslation } from "react-i18next";
import ActionDropdown from "views/components/common/ActionDropdown";
import { IconButton } from "components/common";
const WidgetActionDropdown = ({ children }) => {
  const { t } = useTranslation("widgets");
  const widgetActionDropdownCaret = /* @__PURE__ */ React.createElement(IconButton, { name: "keyboard_arrow_down", title: t("widget_actions.open_dropdown"), showTooltip: false });
  return /* @__PURE__ */ React.createElement(ActionDropdown, { element: widgetActionDropdownCaret }, children);
};
export default WidgetActionDropdown;
